import type { IHierarchyViewSelectItem } from 'components/HierarchyViewSelect/HierarchyViewSelect';
import { HierarchyViewSelect } from 'components/HierarchyViewSelect/HierarchyViewSelect';
import type { WorkOrderChangeObjectItem, WorkOrderObjectData, WorkOrderVersionObjectData } from 'gql/graphql';

import React, { useCallback, useMemo } from 'react';

interface IConstructionSubObjectComboboxProps {
    constructionTypeId: number;
    objectId: number | undefined;
    subObjectId: number | undefined;
    onChange: (selectedItem: IHierarchyViewSelectItem | undefined) => void;
    disabled?: boolean;
    workOrderObjects?: (WorkOrderObjectData | WorkOrderVersionObjectData | WorkOrderChangeObjectItem)[] | null;
}

export const ConstructionSubObjectCombobox = ({
    constructionTypeId,
    objectId,
    subObjectId,
    onChange,
    disabled,
    workOrderObjects,
}: IConstructionSubObjectComboboxProps) => {
    const items = useMemo(() => {
        const objects = objectId && workOrderObjects ? workOrderObjects : [];
        const isAreThereSubObjects = !!objects.filter(({ rootObjectId }) => rootObjectId === objectId).length;

        if (!isAreThereSubObjects) {
            return [];
        }

        return objects
            .filter(({ constructionType }) => constructionTypeId === constructionType.id)
            .map((item) => ({ id: item.id, label: item.name, parentId: item.parentId }));
    }, [constructionTypeId, objectId, workOrderObjects]);

    const selectedItem = useMemo(() => items.find(({ id }) => id === subObjectId), [subObjectId, items]);

    const onLocalChange = useCallback(
        (selected?: IHierarchyViewSelectItem) => {
            onChange(selected);
        },
        [onChange],
    );

    return (
        <HierarchyViewSelect
            disabled={disabled}
            onlyLeafsSelectable
            sortItemsById
            selectedItem={selectedItem}
            items={items}
            onChange={onLocalChange}
            rootId={objectId}
            size="s"
            labelPosition="left"
            placeholder="Подобъекты строительства"
        />
    );
};

ConstructionSubObjectCombobox.displayName = 'ConstructionSubObjectCombobox';
